import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';
import { dependenteBreadcrumbResolver } from './dependente-breadcrumb.resolver';

export const dependenteRoutes: Routes = [
  {
    path: 'dependente',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./dependente.component').then((m) => m.DependenteComponent),
        data: {
          title: 'Meus Dependentes',
          titleByRole: [
            {
              role: Role.DEPENDENTE_COORDENADOR_ANALISAR,
              title: 'Gestão de Dependentes',
            },
            {
              role: Role.DEPENDENTE_COORDENADOR_CADASTRAR,
              title: 'Gestão de Dependentes',
            },
            {
              role: Role.DEPENDENTE_PROFISSIONAL_CADASTRAR,
              title: 'Meus Dependentes',
            },
          ],
          roles: [
            Role.DEPENDENTE_PROFISSIONAL_CADASTRAR,
            Role.DEPENDENTE_COORDENADOR_CADASTRAR,
            Role.DEPENDENTE_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [{ label: 'Meus Dependentes', url: '/dependente' }],
          breadcrumbByRole: [
            {
              role: Role.DEPENDENTE_COORDENADOR_ANALISAR,
              breadcrumb: [{ label: 'Gestão de Dependentes', url: '/dependente' }],
            },
            {
              role: Role.DEPENDENTE_COORDENADOR_CADASTRAR,
              breadcrumb: [{ label: 'Gestão de Dependentes', url: '/dependente' }],
            },
            {
              role: Role.DEPENDENTE_PROFISSIONAL_CADASTRAR,
              breadcrumb: [{ label: 'Meus Dependentes', url: '/dependente' }],
            },
          ],
        },
        resolve: { breadcrumb: dependenteBreadcrumbResolver },
      },
      {
        path: 'novo',
        loadComponent: () => import('./form/dependente-form.component').then((m) => m.DependenteFormComponent),
        data: {
          title: 'Cadastrar Dependente',
          roles: [Role.DEPENDENTE_PROFISSIONAL_CADASTRAR],
          breadcrumb: [
            { label: 'Meus Dependentes', url: '/dependente' },
            { label: 'Cadastrar Dependente', url: '/dependente/novo' },
          ],
        },
        resolve: { breadcrumb: dependenteBreadcrumbResolver },
      },
      {
        path: 'editar/:id',
        loadComponent: () => import('./form/dependente-form.component').then((m) => m.DependenteFormComponent),
        data: {
          title: 'Editar Dependente',
          roles: [Role.DEPENDENTE_EDITAR],
          breadcrumb: [
            { label: 'Meus Dependentes', url: '/dependente' },
            { label: 'Editar Dependente', url: '/dependente/editar' },
          ],
        },
        resolve: { breadcrumb: dependenteBreadcrumbResolver },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () => import('./form/dependente-form.component').then((m) => m.DependenteFormComponent),
        data: {
          title: 'Visualizar Dependente',
          roles: [
            Role.DEPENDENTE_VISUALIZAR,
            Role.DEPENDENTE_PROFISSIONAL_CADASTRAR,
            Role.DEPENDENTE_COORDENADOR_CADASTRAR,
            Role.DEPENDENTE_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Meus Dependentes', url: '/dependente' },
            { label: 'Visualizar Dependente', url: '/dependente/visualizar' },
          ],
        },
        resolve: { breadcrumb: dependenteBreadcrumbResolver },
      },
      {
        path: 'analisar/:id',
        loadComponent: () => import('./form/dependente-form.component').then((m) => m.DependenteFormComponent),
        data: {
          title: 'Análise de Dependente',
          roles: [Role.DEPENDENTE_COORDENADOR_ANALISAR],
          breadcrumb: [
            { label: 'Gestão de Dependentes', url: '/dependente' },
            { label: 'Análise de Dependente', url: '/dependente/analisar' },
          ],
        },
        resolve: { breadcrumb: dependenteBreadcrumbResolver },
      },
    ],
  },
];
